import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { scrollToHash, isMobileOrTablet, toggleBodyClass, isHTMLElement } from '../utils';
gsap.registerPlugin(ScrollToPlugin);

// 記述が多いのもはimport
import { registerBreakPointEvent } from './registerBreakPointEvent';

/**
 * @function rewriteTellink
 * @description PCの場合、<a href="tel:">を<span>に変更、class等attributeはそのまま継承
 * */
const _rewriteAtag = (el: HTMLElement): void => {
  const attributes = el.attributes;
  const innerHtml = el.innerHTML;
  let attributesText = null;
  for (let i = 0; i < attributes.length; i++) {
    const attribute = attributes[i];
    if (attribute.name != 'href') {
      const t = `${attribute.name}="${attribute.textContent}"`;
      attributesText = attributesText == null ? t : `${t} ${attributesText}`;
    }
  }
  if (attributesText == null) {
    el.outerHTML = `<span>${innerHtml}</span>`;
  } else {
    el.outerHTML = `<span ${attributesText}>${innerHtml}</span>`;
  }
};

const rewriteTellink = () => {
  const tel_links = document.querySelectorAll('a[href^="tel:"]') as NodeListOf<HTMLElement>;
  if (tel_links.length && !isMobileOrTablet()) {
    tel_links.forEach((tel_link) => {
      _rewriteAtag(tel_link);
    });
  }
};

/**
 * @function smoothScroll
 * @description ページ内リンクのスムーススクロール
 * */
const _getSamePageAnchor = (url: URL): string => {
  if (url.protocol !== window.location.protocol || url.host !== window.location.host || url.pathname !== window.location.pathname || url.search !== window.location.search) {
    return '';
  }
  return url.hash;
};
const smoothScroll = (): void => {
  const anchor_links = document.querySelectorAll('a[href^="#"]') as NodeListOf<HTMLElement>;
  if (anchor_links.length) {
    anchor_links.forEach((anchor_link) => {
      anchor_link.addEventListener('click', (e) => {
        const hash = anchor_link.getAttribute('href');
        if (hash) {
          const url = new URL(hash);
          scrollToHash(_getSamePageAnchor(url), e);
        }
      });
    });
  }
  if (location.hash) {
    scrollToHash(location.hash, null);
  }
};

/**
 * @function adjustViewport
 * @description viewport 375px以下は width=375 で固定にする
 * */
const adjustViewport = (): void => {
  const triggerWidth = 375;
  const viewport = document.querySelector('meta[name="viewport"]');
  const value = window.outerWidth < triggerWidth ? `width=${triggerWidth}, target-densitydpi=device-dpi` : 'width=device-width, initial-scale=1,maximum-scale=1.0';
  if (viewport) {
    viewport.setAttribute('content', value);
  } else {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = value;
    document.head.appendChild(meta);
  }
};
/**
 * @function setRootProperty
 * @description :root{  }に動的なcss変数を設定
 * */
const setRootProperty = (): void => {
  const root = document.querySelector(':root') as HTMLElement;
  if (root) {
    const window_width = document.body.clientWidth;
    root.style.setProperty('--view-width', `${window_width}px`);
    const html_font_times = window_width / 1000 > 1 ? 1 : window_width / 1000;
    root.style.setProperty('--font-size-times', String(html_font_times));
  }
};

const toggleNav = (): void => {
  const toggles = document.querySelectorAll('[data-nav-toggle]') as NodeListOf<HTMLElement>;
  const gnav = document.getElementById('Gnav');
  if (Array.from(toggles).length && isHTMLElement(gnav)) {
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const is_open = toggleBodyClass('is-nav-open');
        if (is_open) {
          gsap.to(gnav, {
            autoAlpha: 1,
            duration: 0.3,
          });
        } else {
          gsap.to(gnav, {
            autoAlpha: 0,
            duration: 0.3,
          });
        }
      });
    });
  }
};

// export object
const Common = {
  init() {
    registerBreakPointEvent();
    adjustViewport();
    setRootProperty();
    rewriteTellink();
    smoothScroll();
    toggleNav();
  },
  resize() {
    adjustViewport();
    setRootProperty();
  },
  breakPoint() {},
};

export { Common };
